export type KPISummaryUnit = 'percentage' | 'percentage_points';

export const appendKPISummaryUnit = (
  value: string | number,
  unit: KPISummaryUnit
): string => (unit === 'percentage_points' ? `${value} %pt` : `${value}%`);
